import { createRouter, createWebHistory } from 'vue-router';
import HomePage from './components/Home.vue';
import Login from './components/Login.vue';
import ipList from './components/ipList.vue';
import changeList from './components/changeList.vue';
import userList from './components/userList.vue';
import ipAdd from './components/ipAdd.vue';
import admin from './components/Admin.vue';
import api from './api';
import { download } from 'fontawesome';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/ip/list',
    name: 'IP List',
    component: ipList,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/admin/changes',
    name: 'Change List',
    component: changeList,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/admin/users',
    name: 'User List',
    component: userList,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/ip/add',
    name: 'Add IP',
    component: ipAdd,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/download',
    beforeEnter() {location.href = 'https://geofeed.oriontelekom.rs/api/v1/download'},
    component: download
  },
  {
    path: '/admin',
    name: 'Administration',
    component: admin,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/logout',
    component: () => import('@/components/logoutPage.vue'),
    name: 'Logout',
    meta: {
      requiresAuth: true,
    },
  }
/**  {
    path: '/stats',
    name: 'Statistics',
    component: RadiusStats,
      meta: {
        requiresAuth: true,
      },
  }
*/
];

const router = createRouter({
  history: createWebHistory('/'),
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.name;
  const isAuthenticated = localStorage.getItem('token');

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isAuthenticated && isAuthenticated === null) {
      // Redirect to login page if not authenticated
      window.location.replace("/login");
    } else {
      // Validate the token here
      api.post('/check_token', {}, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
        }
      }).then((response) => {
        response = response.data;
        if(response.message === 'success' ) {
          next();
        } else {
          next('/login');
        }
      }).catch((error) => {
        next('/login');
        return error.response;
      });
      }
  } else {
    // If the route doesn't require authentication, proceed as usual
    next();
  }
});

export default router;
